// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)
